import { useCallback, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { exportToExcel } from "../../../../util";

const pagOptions = {
    rowsPerPageText: "Filas por páginas",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos"
};

const PanelTrazabilidad = (props: any) => {

    let [records, setRecords] = useState(props.data);
    const [seleccionadas, setSeleccionadas] = useState<any[]>([]);
    const [limpiarSeleccion, setLimpiarSeleccion] = useState(false);
    const [filtro, setFiltro] = useState("");
    const [exportando, setExportando] = useState(false);

    const changeTextFiltro = (evnt: any) => {
        setFiltro(evnt.target.value);
        setSeleccionadas([]);
        setLimpiarSeleccion(valor => !valor);
        const texto = evnt.target.value.trim().toUpperCase();
        if (texto === "") {
            setRecords([...props.data]);
        } else {
            records = [...props.data];
            const reg = records.filter((dato: any) => {
                return props.columns.some((col: any) => {
                    const valor = col.selector ? col.selector(dato) : null;
                    return (valor !== null) && (valor !== undefined) && valor.toString().toUpperCase().includes(texto);
                });
            });
            setRecords([...reg]);
        }
    }

    useEffect(() => {
        setRecords(props.data);
        setFiltro("");
        setSeleccionadas([]);
        setLimpiarSeleccion(valor => !valor);

    }, [props.data]);

    const hndlrSeleccion = useCallback(({ selectedRows }: any) => setSeleccionadas(selectedRows), []);

    // sin filas marcadas se exporta todo lo que hay en la grilla
    const aExportar = (seleccionadas.length > 0) ? seleccionadas : records;

    // cada pestaña exporta su propio excel con el detalle por SKU de las filas a exportar
    const hndlrExportar = async () => {

        if (exportando || aExportar.length === 0) return;
        setExportando(true);
        try {
            const detalle = await props.buscaDetalle(props.id, aExportar);
            if (!detalle) return;
            const periodo = `${props.formData.Anno}${props.formData.Mes}`;
            exportToExcel(`Trazabilidad_${props.id}_detalle_${periodo}`, detalle);
        } finally {
            setExportando(false);
        }
    }

    return (
        <>
            <div className="d-flex flex-column col col-lg-6 col-md-12 mb-3 mt-4">
                <label className="m-1">Filtro</label>
                <input type="text" id={`txtBuscar-${props.id}`} className="form-control m-1" value={filtro} onChange={changeTextFiltro} />
            </div>
            <div className="m-1 mb-3 d-flex align-items-center">
                <Button type="button" className="border-0" style={{ backgroundColor: "#16D39A" }}
                    disabled={exportando || aExportar.length === 0}
                    onClick={hndlrExportar}>
                    Exportar
                </Button>
                <label className="ms-3 text-muted">{`${seleccionadas.length ? "Filas seleccionadas" : "Sin selección: todas las filas filtradas"}: ${aExportar.length} de ${records.length}`}</label>
            </div>
            <DataTable
                columns={props.columns.map(({ width, ...column }: any) => ({
                    ...column,
                    minWidth: width,
                    grow: 1,
                }))}
                data={records}
                responsive
                selectableRows
                selectableRowsHighlight
                onSelectedRowsChange={hndlrSeleccion}
                clearSelectedRows={limpiarSeleccion}
                fixedHeader
                pagination
                highlightOnHover
                fixedHeaderScrollHeight="600px"
                paginationComponentOptions={pagOptions}
            />
        </>
    )
};

export default PanelTrazabilidad;
